import { Box, Typography } from '@mui/material'
import { SelectedTask, OrganizationTableItem } from 'types'

type SelectedData = SelectedTask | OrganizationTableItem

const SubmittingFor = ({ selectedData }: { selectedData: SelectedData }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 1,
        ml: 'auto',
        minWidth: 0,
      }}
    >
      <Typography sx={{ fontSize: 12, color: 'text.secondary', flexShrink: 0 }}>Submitting for:</Typography>
      <Typography
        sx={{
          fontSize: 12,
          color: 'text.primary',
          maxWidth: 180,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
        title={selectedData?.title || selectedData?.name || selectedData?.label}
      >
        {selectedData?.title || selectedData?.name || selectedData?.label}
      </Typography>
    </Box>
  )
}
export default SubmittingFor
